import { Component } from '@angular/core';
import { AlertsService } from './core/services/alerts.service';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'aim-portal';
  
  constructor(private oktaService: OktaService,
    private router: Router){}

  private onDestroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    this.oktaService
      .onNewOktaError()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((error) => {
        console.log('Error ', error);
        if (error) {
          if (error.error === 'access_denied') {
            this.router.navigateByUrl('/unauthorized');
          }
        } 
      });
  }
}
